// Navbar.elements.js
import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { IconButton } from "@mui/material";
import { NavLink as RouterNavLink } from "react-router-dom";
import { CrossButton } from "../CrossButton/CrossButton";

export const NavPlaceholder = styled.div`
    position: relative;
    flex-basis: 0;
    width: 0;
    flex-shrink: 0;
    height: 100%;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        flex-basis: ${({ isCollapsed }) => (isCollapsed ? "72px" : "280px")};
        width: ${({ isCollapsed }) => (isCollapsed ? "72px" : "280px")};
        transition: width 0.2s, flex-basis 0.2s;
    }
`;

export const NavContainer = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;

    width: 100vw;

    translate: ${({ isMobileMenuOpen }) => (isMobileMenuOpen ? "0 0" : "-100% 0")};
    transition: translate 0.2s;

    background: ${({ theme }) => theme.palette.primary.dark3};
    z-index: 1200;
    border-right: 1px solid rgba(255, 255, 255, 0.08);

    display: flex;
    flex-direction: column;

    @media screen and (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        position: relative;
        width: 100%;
        height: 100%;
        translate: 0;
        z-index: 1;
    }
`;

export const NavHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    width: 100%;
    padding: 0 12px;
`;

export const NavHeaderDivider = styled.div`
    height: 1px;
    width: 100%;
    background: rgba(255, 255, 255, 0.08);
`;

export const MobileCloseButton = styled(CrossButton)`
    > svg {
        width: 18px;
        height: 18px;
    }
`;

export const CollapseButton = styled(IconButton)`
    rotate: ${({ isCollapsed }) => (isCollapsed ? "180deg" : "0deg")};
    transition: rotate 0.2s;
`;

export const Nav = styled.nav`
    display: flex;
    flex-direction: column;
    padding: 12px;
    flex: 1;
    overflow-y: auto;
`;

export const NavIcon = styled.span`
    flex-shrink: 0;
    width: 22px;
    height: 22px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
`;

export const NavLabel = styled("span", {
    shouldForwardProp: (prop) => prop !== "isCollapsed",
})`
    white-space: nowrap;

    ${({ isCollapsed }) =>
            isCollapsed &&
            css`
      display: none;
    `}
`;

export const NavLink = styled(RouterNavLink, {
    shouldForwardProp: (prop) => prop !== "isCollapsed",
})`
    display: flex;
    align-items: center;
    gap: 14px;
    height: 48px;
    padding: 0 12px;
    border-radius: 10px;
    color: #f7fafaa6;
    overflow: hidden;

    justify-content: ${({ isCollapsed }) => (isCollapsed ? "center" : "flex-start")};

    ${({ isCollapsed }) =>
            isCollapsed &&
            css`
      gap: 0;
    `}

    &:hover {
        background-color: #1b2432;
        color: white;

        ${NavIcon} {
            color: #f5c754;
        }
    }

    &.active {
        background-color: #29384d;
        color: white;

        ${NavIcon} {
            color: #f5c754;
        }
    }
`;

export const NavDivider = styled.hr`
  border: none;
  border-top: 1px solid #29384D;
  margin: 8px 0;
`;